/**
 * Our window size breakpoints in English form. Easier to think around compared to hard numbers.
 */ export var WindowBreakpoint;
(function(WindowBreakpoint) {
    WindowBreakpoint["DesktopAverageSize"] = "average-desktop";
    WindowBreakpoint["DesktopSmallSize"] = "small-desktop";
    WindowBreakpoint["MobileAverageSize"] = "average-mobile";
})(WindowBreakpoint || (WindowBreakpoint = {}));
export var ElementVisibility;
(function(ElementVisibility) {
    /**
   * Where all the action happens. The bar directly under the deviation
   */ ElementVisibility["PrimaryBar"] = "primary-bar";
    /**
   * For now, a purely mobile placement. Below the primary bar.
   */ ElementVisibility["SecondaryBar"] = "secondary-bar";
    /**
   * Collapsed into the more actions menu
   */ ElementVisibility["Menu"] = "menu";
    /**
   * Completely excluded. Nothing. Nowhere.
   */ ElementVisibility["NotIncluded"] = "not-included";
})(ElementVisibility || (ElementVisibility = {}));
export const NOT_INCLUDED_VISIBILITY_GROUP = {
    groupVisibility: "not-included",
    countOnBar: 0
};
